import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Divider
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';

import { Tabs } from '../../../components/tabs';

import { CONFIG } from '../../../../config'
import AllCalls from './views/calls.view';

const API_HOST = CONFIG.modules['accounts'].host

// THis is the worst frontend architecture I have ever seen
// I am sorry future developer who will mainting this code
// Instead of doing routing and presenting different page
// This programmatically renders different components based on the active tab
// Which means every refresh will reset the active tab to Overview
// This is not a good practice, but it is what it is SCREW IT
const items = {
    "Calls": {
        name: "Calls",
        view: (socket) => <AllCalls />,
    },


};

const markStyle = { borderRadius: 1, ml: 2, minWidth: 300, background: '#F3D55B', mb: 3, height: 40, pl: 2, display: 'flex', alignItems: 'center' }

const wrap = { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }
const text2 = { fontSize: '.8em' }
export const CallsIndex = (props) => {

    // variables relation to socket

    const { roles, user, users, Designations, Departments, Languages, Districts, Campaigns } = useSelector((state) => (state.user || {}))
    const { state } = props.location


    console.log(state, 'props route');

    const [active, setActive] = useState('Calls')


    return (
        <>
            <Tabs
                items={items}
                active={active}
                state={state}
                onChange={(key) => {
                    setActive(key)
                }}
            />
            {
                items[active] && items[active].view && //props.socket &&
                items[active].view(props.socket)
            }

        </>
    )
}